import { FloatingNav } from '@components/ui/FloatingNav';
import { NAV_PAGES } from '@constants/index';

export default function StandarLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <FloatingNav navItems={NAV_PAGES} />
      <main className="py-10 px-3 sm:px-8 md:px-20 dark:bg-black-100 ">{children}</main>
    </>
  );
}
